import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "className", "sr", "description", "error"];
import clsx from "clsx";
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line react/display-name
export var Input = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    children,
    className,
    sr,
    description,
    error
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("label", {
      htmlFor: rest.id,
      className: clsx("block font-medium", {
        "sr-only": sr,
        "p-1 mb-1": !sr
      }),
      children: children
    }), /*#__PURE__*/_jsxs("div", {
      className: "relative",
      children: [/*#__PURE__*/_jsx("input", _extends({
        ref: ref,
        className: clsx("w-full focus:ring block px-3 py-1.5 border border-grey-300/20 rounded", {
          "border-red-400": error
        }, className)
      }, rest)), description && /*#__PURE__*/_jsx("small", {
        className: "p-1 opacity-50",
        children: description
      }), error && /*#__PURE__*/_jsx("small", {
        className: "text-red-400 p-1",
        children: error
      })]
    })]
  });
});
//# sourceMappingURL=input.js.map